module.exports = new __parcel__URL__("innova.aaed09f7.jpg").toString();